<template>
  <div>
    <div class="d-flex align-center justify-space-between mb-2">
      <v-banner
        v-if="arenaId"
        outlined
        rounded
        single-line
        color="grey"
        icon="mdi-exclamation"
        class="flex-grow-0 last-invoice-banner">
        <template v-if="isLoadingNewestInvoice">
          {{ $t('entities.invoices.lastInvoiceDate') }}: ...
        </template>
        <template v-else>
          {{ $t('entities.invoices.lastInvoiceDate') }}:
          {{ formatDateValue(newestInvoice.created_at) }}
        </template>
      </v-banner>
      <GlobalButton
        :route="transactionsRoute"
        :text="$t('entities.invoices.transactions')"
        icon="receipt" />
    </div>
    <v-card class="elevation-2">
      <InvoicesDataTable
        :initialLoad.sync="initialLoad"
        :loading.sync="loading"
        :title="$t('entities.invoices.title')" />
    </v-card>
  </div>
</template>

<script>
import Vue from 'vue'
import GlobalButton from '@/components/GlobalButton.vue'
import InvoicesDataTable from '@/components/invoices/InvoicesDataTable'
import Invoice from '@/models/shop/Invoice'
import formatDate from '@/mixins/format-date'

export default Vue.extend({
  components: {
    GlobalButton,
    InvoicesDataTable,
  },

  mixins: [formatDate],

  data: () => ({
    initialLoad: true,
    loading: false,
    newestInvoice: null,
    isLoadingNewestInvoice: false,
  }),

  computed: {
    transactionsRoute() {
      return '/transactions-v1'
    },
    arenaId() {
      return this.$store.getters?.arena?.id
    },
  },

  created() {
    this.fetchNewestInvoice()
  },

  methods: {
    async fetchNewestInvoice() {
      const arenaId = this.arenaId
      if (!arenaId) {
        this.newestInvoice = null
        return
      }

      this.isLoadingNewestInvoice = true
      try {
        const query = `&arena_id=${arenaId}&per_page=1&page=1`
        const response = await Invoice.api.get(1, query)
        const data = response.data?.data || []
        this.newestInvoice = data.length > 0 ? new Invoice(data[0]) : null
      } catch (error) {
        console.error('Failed to fetch newest invoice.', error)
        this.newestInvoice = null
      } finally {
        this.isLoadingNewestInvoice = false
      }
    },
    formatDateValue(value) {
      if (!value) return '-'
      const parsed = new Date(value)
      if (Number.isNaN(parsed.getTime())) return value
      return this.formatDate(parsed, true, true)
    },
  },

  watch: {
    arenaId() {
      this.fetchNewestInvoice()
    },
  },
})
</script>

<style>
.position-relative {
  position: relative;
}

.required-fields {
  position: absolute;
  right: 13px;
  top: 15px;
  color: red;
}

.last-invoice-banner {
  width: fit-content;
}
</style>
